// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getVisualListingGridSizes } from '../../utils/gridHelpers';
import InfiniteGrid from './items/InfiniteGrid';
import VerticalItem from './items/VerticalItem';
import * as Styles from './VisualListing.scss';
export default function VisualListing(props) {
    useStyles(Styles);
    // Grab data from props and Redux store.
    const { data, handleSelected } = props;
    const { header, button } = data;
    const { windowWidth } = useSelector((state) => state.BrowserState);
    const onButtonClick = button ? () => { var _a, _b; return handleSelected((_b = (_a = button) === null || _a === void 0 ? void 0 : _a.primaryLink) === null || _b === void 0 ? void 0 : _b.onItemSelected); } : null;
    return (React.createElement(Fragment, null,
        header && React.createElement("div", { className: Styles.header },
            React.createElement("h1", { className: 'music-headline-4' }, header)),
        button &&
            React.createElement("div", { className: Styles.buttonContainer },
                React.createElement("music-button", { "icon-name": button.icon, size: "medium", onmusicActivate: onButtonClick }, button.text)),
        React.createElement(InfiniteGrid, { data: props.data, handleSelected: props.handleSelected, componentType: VerticalItem, gridSizes: getVisualListingGridSizes(windowWidth), isEnumerated: this.props.isEnumerated })));
}
;
